import axios from 'axios';

class PartnerAPI {
  static isValid(id: string, code: string | null): Promise<boolean> {
    return new Promise((resolve, reject) => {
      let { ajaxUrl } = window.ioappConfig;
      const { protocol } = window.location;

      if (protocol !== 'https:') {
        ajaxUrl = ajaxUrl.replace('https://', 'http://');
      }

      axios.get(ajaxUrl, {
        params: {
          action: 'partner',
          endpoint: 'validate',
          id,
          code,
        },
      }).then(() => {
        resolve(true);
      }).catch((e) => {
        reject(e);
      });
    });
  }
}

export default PartnerAPI;
